import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-servicesfr',
  templateUrl: './servicesfr.component.html',
  styleUrls: ['./servicesfr.component.css']
})
export class ServicesfrComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
